import styled from "styled-components";
import { desktop } from "../../globalAssets/fontsize";
import PhoneInput from "react-phone-input-2";
import { device } from "../../globalAssets/breakpoints";

export const Account = styled.p`
  color: ${(props) => props.theme.color};
  font-weight: 400;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  margin: 10px 0 0 0;
  & > span {
    color: ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    font-size: ${desktop.small};
    margin: 1.4vw 0 0 0;
  }
`;
export const StyledInput = styled(PhoneInput)``;
export const InputDiv = styled.div`
  .containerStyle {
    background: ${(props) => props.theme.foreground} !important;
    width: 100% !important;
    border: 1px solid ${(props) => props.theme.subtleBlack};
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
    .inputStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none !important;
      color: ${(props) => props.theme.color};
      width: 100% !important;
      font-size: 14px;
      :active,
      :focus,
      :hover {
        border: 1px solid ${(props) => props.theme.primaryColor};
      }
    }
    .dropdownStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none !important;
      color: ${(props) => props.theme.color};
      font-size: 14px;
      :active,
      :focus,
      :hover {
        border: 1px solid ${(props) => props.theme.primaryColor};
        background: ${(props) => props.theme.foreground} !important;
        color: ${(props) => props.theme.color};
      }
    }
    .buttonStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none;
      border-right: 1px solid ${(props) => props.theme.black};
      color: ${(props) => props.theme.color};
      font-style: 14px;
      :active,
      :focus,
      :hover {
        background: ${(props) => props.theme.foreground} !important;
      }
    }
    .searchStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none;
      border-right: 1px solid ${(props) => props.theme.black};
      color: ${(props) => props.theme.color};
      font-size: 14px;
      :active,
      :focus,
      :hover {
        background: ${(props) => props.theme.foreground} !important;
      }
    }
    @media ${device.laptop} {
      .inputStyle {
        font-size: ${desktop.small};
      }
      .dropdownStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
      .buttonStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
      .searchStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
    }
  }
`;

export const Text2 = styled.span`
  font-size: 11px;
  text-align: center;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;
export const Text1 = styled.h5`
  color: ${(props) => props.theme.primaryColor};
  margin-left: 10px;
  font-size: 13px;
  & > span {
    color: ${(props) => props.theme.primaryColor};
    cursor: pointer;
  }
  @media ${device.laptop} {
    font-size: 11px;
    /* font-weight: 600; */
  }
`;

export const NotificationText = styled.h4`
  font-size: 14px;
  text-align: center;
  color: ${(props) => props.theme.color};
  margin: 0;
  span {
    font-weight: 600;
    color: ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    font-size: ${desktop.normal};
  }
`;
